/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {Fragment} from "react";
import {Form, FormListener} from "../form/Form";
import {CasinoGame, CasinoGameType, CasinoLobbyCategory, GameTag, ListCasinoGameRequest} from "../../http/protocol";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {LoadingViewState, RouterView} from "../RouterView";
import {Validators} from "../form/Validators";
import {SelectInput} from "../form/SelectInput";
import {CasinoCategoryService} from "../../services/CasinoCategoryService";
import {CasinoGameService} from "../../services/CasinoGameService";
import {AddCasinoGames} from "./AddCasinoGames";
import {changePosition, removeItemFromArray} from "../../util/ArrayUtils";

interface State extends LoadingViewState {
    category? : CasinoLobbyCategory;
    validationMap? : any;
    gameTypes? : CasinoGameType[];
    showAddGames?: boolean;
    gamesCache? : CasinoGame[];
    tags? : GameTag[];
}

interface Props extends RouteComponentProps {

}

export class CasinoCategoryView extends RouterView<Props,State> implements FormListener<CasinoLobbyCategory>{

    service : CasinoCategoryService;
    gameService : CasinoGameService;
    tagService : CasinoGameService;
    draggedEndGameId:any;
    draggedStartGameId:any;

    constructor(props : Props){
        super(props);
        this.service = getContainer().getCasinoCategoryService();
        this.gameService = getContainer().getCasinoGameService();
        this.tagService = getContainer().getCasinoGameTagService();
        //TODO fetch types from server
        let types = [CasinoGameType.ARCADE_GAMES, CasinoGameType.LIVE_CASINO, CasinoGameType.SLOTS, CasinoGameType.TABLE_GAMES, CasinoGameType.VIDEO_POKER, CasinoGameType.OTHER];
        this.state = { tags: [], category : { types : [], games : []}, validationMap : {}, loading : true, gameTypes : types, showAddGames : false, gamesCache : []};
    }

    loadContent() : Promise<any> | undefined {
        var id = (this.props.match.params as any).id;
        if(id && id!== "new") {
            return this.service.getEntity(id).then((c : CasinoLobbyCategory) => {
                return this.tagService.list({limit : 100, offset: 0, orderBy : "name", ascending : true} as any).then((tags)=>{

                    if(c.games && c.games.length > 0) {
                        this.setState({ tags : tags.items });
                        let lq : ListCasinoGameRequest = { gameIds : c.games, limit: 1000, offset : 0, orderBy : "id"};
                        return this.gameService.list(lq).then(gameList => {
                            this.setState({ category : c, gamesCache : gameList.items});
                        });
                    } else {
                        this.setState({ category : c, tags : tags.items});
                    }
                })

            })
        } else{
            return this.tagService.list({limit : 100, offset: 0, orderBy : "name", ascending : true} as any).then((tags)=>{
                this.setState({ tags : tags.items, category : { types : [], games : [] }});
            })
        }

    }
    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        if((this.props.match.params as any).id !== (prevProps.match.params as any).id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    onSubmit():Promise<any> {
        if(!this.state.category) {
            return Promise.reject("Unable to save attribute");
        }
        return this.service.save(this.state.category).then( (a : CasinoLobbyCategory) => {
            if((this.props.match.params as any).id == "new") {
                this.navigate("/casino-category/" + a.id);
            } else {
                this.setState({ category : a });
            }

        }).catch(err=>{
            throw Error("Unable to create/save user");
        });
    }

    onSubmitError(){}

    formDidUpdate(formModel:CasinoLobbyCategory, validationMap : any) {
        this.setState({ category : formModel, validationMap : validationMap});
    }


    getTitle() : string {
        return "Edit/Create Category";
    }

    addGame(game : CasinoGame) {
        console.log("ADD GAME = ", game);
        if(this.state.category && this.state.category.games && this.state.gamesCache) {
            let games : number[] = this.state.category.games.concat();
            if(game.id) {
                games.push(game.id);
                let category = Object.assign({}, this.state.category, { games  : games} )
                let cache = this.state.gamesCache.concat();
                cache.push(game);
                this.setState({ category : category, gamesCache : cache });
            }
        }
    }
    removeGame(gameId : number) {
        if(this.state.category && this.state.category.games && this.state.gamesCache) {
            let games = removeItemFromArray(this.state.category.games, g => g == gameId);
            let cache = removeItemFromArray(this.state.gamesCache, g => g.id == gameId);
            let category = Object.assign({}, this.state.category, { games  : games} )
            this.setState({ category : category, gamesCache : cache });
        }
    }
    getGame(gameId : number) : CasinoGame | undefined {
        if(this.state.gamesCache) {
            let game = this.state.gamesCache.find(g => gameId == g.id);
            if(game) {
                return game;
            }
        }
        return undefined;
    }
    addTranslation(lang : string, value : string) {
        if(this.state.category) {
            let trans = Object.assign({}, this.state.category.translations);
            trans[lang] = value;
            this.setState({ category : {...this.state.category,  translations : trans }});
        }
    }
    removeTranslation(lang : string) {
        if(this.state.category) {
            let trans = Object.assign({}, this.state.category.translations);
            delete trans[lang];
            this.setState({ category : {...this.state.category,  translations : trans }});
        }
    }
    renderContent() {
        if(!this.state.category || !this.state.gameTypes || !this.state.gamesCache || !this.state.tags) {
            return <span></span>
        }
        // console.log("GAMES =", this.state.category.games);
        return (

            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.category} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Category was updated successfully"/>

                                    <FormGroup className="form-group mb-3" model="name">
                                        <label>Name </label>
                                        <FormInput className="form-control" model="name" type="text" validators={[Validators.required()]}/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label>Enabled</label><br/>
                                        <FormInput id={"enabled"} model="enabled" type="checkbox" /><br/>
                                        <span className={"help-text"}>When checked displays only enabled casino categories. Only enabled casino categories are visible on the player frontend.</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="lobbyOrder">
                                        <label>Lobby Order </label>
                                        <FormInput className="form-control" model="lobbyOrder" type="integer" validators={[Validators.required(), Validators.integer()]}/>
                                        <span className={"help-block"}>The display order on the site, displayed in descending  order(higher first)</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="types">
                                        <label>Game Types</label>
                                        <SelectInput optional={true} multiple={true} size={this.state.gameTypes.length} values={this.state.gameTypes} className="form-control" model="types"/>
                                        <span className={"help-block"}>Select the game type(s) you want to include in this category. All games with this type will be included.</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="tags">
                                        <label>Game Tags</label>
                                        <SelectInput optional={true} multiple={true} size={this.state.tags.length} values={this.state.tags} className="form-control" model="tags" optionModelValue={(t)=>t.id} displayValue={(t)=>t.name}/>
                                        <span className={"help-block"}>Select the game tag(s) you want to include in this category. All games with this tag will be included.</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group mb-3" model="slug">
                                        <label>Slug </label>
                                        <FormInput className="form-control" model="slug" type="text" validators={[Validators.regExp(/^([a-z]+|\d*([a-z]|[a-z\-]){1,}[a-z]\d*)$/g)]}/>
                                        <span className={"help-block"}>This value is used when building urls in the frontend that are related to this category ie a url for a game. It should comply with rules for a url path or be empty. It should not have the character /, nor contain full paths or domains. If empty applications will use the category name. It can not be shared with other categories.</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>
                                    <div className={"row"}>
                                        <div className={"col-12"}>
                                            <h4>Games</h4>
                                        </div>
                                    </div>
                                    {this.state.category.name && this.state.category.name.toUpperCase()=='RECOMMENDED'&&
                                        <div className={"row"}>
                                            <div className={"col-12"}>
                                                <span className={"help-block"}>Drag and drop the games in the order you want to appear on the site</span>
                                            </div>
                                        </div>
                                    }
                                    <div className={"row"}>
                                        <div className={"col-12"}>
                                            <div className={"games-list drag-n-drop-container"}>

                                                {this.state.category.games && this.state.category.games.length > 0 && (
                                                    <table className={"table table-striped"}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Id</th>
                                                            <th>Name</th>
                                                            <th>Integration</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.category.games.map((gameId: number) => (
                                                            <tr key={gameId} onDragOver={() => this.onDragOver(gameId)}
                                                                onDragStart={e => this.onDragStart(e, gameId)}
                                                                onDragEnd={() => this.onDragEnd(gameId)}>
                                                                {((game?: CasinoGame) => {
                                                                    return (
                                                                        <Fragment>
                                                                            <td className="drag" draggable><i
                                                                                className="fe-menu"/></td>
                                                                            <td>{gameId}</td>
                                                                            <td>{game && game.name}</td>
                                                                            <td>{game && game.integration}</td>
                                                                        </Fragment>
                                                                    )

                                                                })(this.getGame(gameId))}

                                                                <td><a  onClick={() => this.removeGame(gameId)}
                                                                       className={"btn btn-danger"}>Remove</a></td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                                {(!this.state.category.games || this.state.category.games.length == 0) &&
                                                <span>No games added to this category</span>}
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-12"}>
                                                <a  className={"btn btn-primary"} onClick={()=>this.toggleShowAddGames(true)}><i className={"fe-plus-square"}></i> Add Games</a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className={"card"}>
                        <div className="card-body">
                            <div className={"row"}>
                                <div className={"col-lg-12"}>
                                    <h4>Translations</h4>
                                    {this.state.category && this.state.category.translations && Object.keys(this.state.category.translations).map( k => {
                                        return (
                                            <div className={"form-inline"}>
                                                {k &&   <input className={"form-control"} value={k} type={"text"} disabled={true}/> }
                                                {this.state.category && this.state.category.translations &&  <input value={ this.state.category.translations[k]} className={"form-control"}  type={"text"} disabled={true}/>}
                                                <a  className={"btn btn-danger"} onClick={()=>this.removeTranslation(k)}>Remove</a>
                                            </div>
                                        )
                                    })}
                                    <br/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 form-inline">
                                    <div className="hr-line-dashed"></div>
                                    <AddTranslation onAdd={(lang,value) => this.addTranslation(lang,value)}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Category</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>
                <AddCasinoGames addGame={(game)=>this.addGame(game)}
                                removeGame={(game)=> { game.id && this.removeGame(game.id) }}
                                showAddGames={this.state.showAddGames}
                                addedGames={this.state.gamesCache}
                                toggleShowAddGames={(show) => this.toggleShowAddGames(show)}/>


            </Fragment>
        )
    }
    toggleShowAddGames(show : boolean) {
        this.setState({ showAddGames : show });
    }

    onDragStart = (e:any, gameId:any) => {
        console.log("onDragStart");
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/html", e.target.parentNode);
        e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);

        this.draggedStartGameId=gameId;
    };

    onDragOver = (index: any) => {
        console.log("onDragOver");

        this.draggedEndGameId = index;
    };


    onDragEnd = (gameId: any) => {
        console.log("onDragEnd ");

        if (this.state.category && this.state.category.games && this.state.gamesCache) {

            let games = changePosition(this.state.category.games, g => g == this.draggedStartGameId, g => g == this.draggedEndGameId);
            let cachedGames = changePosition(this.state.gamesCache, g => g.id == this.draggedStartGameId, g => g.id == this.draggedEndGameId);
            let category = Object.assign({}, this.state.category, {games: games})

            this.setState({category: category, gamesCache: cachedGames});

        }
    };

}
interface AddTranslationProps { onAdd : (lang: string, val : string) => void }
class AddTranslation extends React.Component<AddTranslationProps, {lang : string, value : string}> {
    constructor(props : AddTranslationProps) {
        super(props);
        this.state = { lang : "", value : ""}
    }
    add() {
        if(this.state.lang.length > 0 && this.state.value.length > 0) {
            this.props.onAdd(this.state.lang, this.state.value);
            this.setState({ lang : "", value : ""});
        }
    }
    render() {
        return (
            <div className={"form-group"}>
                <label className={"col-3"}>Add Translation</label>
                <div className={"col-4"}>
                    <input type={"text"} value={this.state.lang} onChange={(e)=>this.setState({ lang : e.target.value, value : this.state.value})} className={"form-control"} placeholder={"Language code"}/>
                </div>
                <div className={"col-4"}>
                    <input type={"text"} value={this.state.value} onChange={(e)=>this.setState({ lang : this.state.lang, value : e.target.value})} className={"form-control"} placeholder={"Name in Language"}/>
                </div>
                <div className={"col-1"}>
                    <a  className={"btn btn-primary"} onClick={()=>this.add()}>Add</a>
                </div>

            </div>
        )
    }
}

export default withRouter(CasinoCategoryView);